module.exports = __webpack_public_path__ + "img/dress side invisible zipper length.dc14064c.png";